import React, { useEffect, useState } from 'react';
import './MessageInput.css';

// MessageInput now supports optional controlled value via `value` and `onChangeValue`
// If not provided, it falls back to internal state (backwards compatible)
function MessageInput({ onSend, disabled, placeholder, value, onChangeValue }) {
  const isControlled = typeof value === 'string' && typeof onChangeValue === 'function';
  const [internalInput, setInternalInput] = useState(value || '');

  // Keep internal state in sync if switching to controlled or when value changes
  useEffect(() => {
    if (!isControlled) return;
    // When controlled, mirror external value to internal for display
    setInternalInput(value);
  }, [value, isControlled]);

  const getInput = () => (isControlled ? value : internalInput);
  const setInput = (v) => (isControlled ? onChangeValue(v) : setInternalInput(v));

  const handleSubmit = (e) => {
    e.preventDefault();
    const current = getInput();
    if (current.trim() && !disabled) {
      onSend(current.trim());
      setInput('');
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  return (
    <form className="message-input" onSubmit={handleSubmit}>
      <input
        type="text"
        value={getInput()}
        onChange={(e) => setInput(e.target.value)}
        onKeyPress={handleKeyPress}
        placeholder={placeholder}
        disabled={disabled}
        className="message-input-field"
      />
      <button
        type="submit"
        disabled={disabled || !getInput().trim()}
        className="message-input-button"
      >
        Send
      </button>
    </form>
  );
}

export default MessageInput;
